import React, { useContext } from "react";
import { Card } from "react-bootstrap";
import ImageRP from "@/components/ImageRP";
import { Typography } from "@mui/material";
import { GlobalContext } from "@/helpers/contexts/contexts";
import { USER_ROLE } from "@/config/constants";

const BootstrapCard = Card as React.ElementType;

const BrandLogoCard = () => {
  const { selectedBrand, loggedInUserRole, loggedInUser } = useContext(
    GlobalContext
  ) as {
    selectedBrand?: { brand_logo?: string };
    loggedInUserRole?: string;
    loggedInUser?: { logo_name?: string };
  };
  return (
    <div className="brand-info-card-wrapper pl-2">
      <Typography color="text.primary" className="grid-title">
        Brand Logo
      </Typography>
      <BootstrapCard className="brand-info-card brand-logo-card">
        <div className="h-100 d-flex align-items-center justify-content-center">
          <ImageRP
            src={
              loggedInUserRole === USER_ROLE.BRAND_OWNER.NAME ||
              loggedInUserRole === USER_ROLE.BRAND_USER.NAME
                ? loggedInUser?.logo_name
                : selectedBrand?.brand_logo
            }
            type="BRAND"
            alt="Brand Logo"
            className="logo-image-container"
          />
          <span className="text-muted d-none">Image failed to load</span>
        </div>
      </BootstrapCard>
    </div>
  );
};

export default BrandLogoCard;
